"use strict";

var cov_1lk1ozh6e6 = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\selections\\helpers.js";
  var hash = "bc8b9987ef6a3617a3618950eea28f7c101eeeca";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\selections\\helpers.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 35
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 19
        },
        end: {
          line: 7,
          column: 21
        }
      },
      "2": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 14,
          column: 3
        }
      },
      "3": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 13,
          column: 53
        }
      },
      "4": {
        start: {
          line: 13,
          column: 26
        },
        end: {
          line: 13,
          column: 51
        }
      },
      "5": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 15,
          column: 20
        }
      },
      "6": {
        start: {
          line: 18,
          column: 30
        },
        end: {
          line: 34,
          column: 1
        }
      },
      "7": {
        start: {
          line: 19,
          column: 20
        },
        end: {
          line: 19,
          column: 50
        }
      },
      "8": {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 20,
          column: 79
        }
      },
      "9": {
        start: {
          line: 20,
          column: 52
        },
        end: {
          line: 20,
          column: 78
        }
      },
      "10": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 28,
          column: 5
        }
      },
      "11": {
        start: {
          line: 22,
          column: 27
        },
        end: {
          line: 22,
          column: 38
        }
      },
      "12": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 27,
          column: 5
        }
      },
      "13": {
        start: {
          line: 24,
          column: 20
        },
        end: {
          line: 24,
          column: 46
        }
      },
      "14": {
        start: {
          line: 25,
          column: 25
        },
        end: {
          line: 25,
          column: 43
        }
      },
      "15": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 35
        }
      },
      "16": {
        start: {
          line: 29,
          column: 16
        },
        end: {
          line: 32,
          column: 36
        }
      },
      "17": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 33,
          column: 15
        }
      },
      "18": {
        start: {
          line: 46,
          column: 33
        },
        end: {
          line: 55,
          column: 1
        }
      },
      "19": {
        start: {
          line: 47,
          column: 53
        },
        end: {
          line: 47,
          column: 57
        }
      },
      "20": {
        start: {
          line: 48,
          column: 26
        },
        end: {
          line: 52,
          column: 3
        }
      },
      "21": {
        start: {
          line: 53,
          column: 20
        },
        end: {
          line: 53,
          column: 51
        }
      },
      "22": {
        start: {
          line: 54,
          column: 2
        },
        end: {
          line: 54,
          column: 19
        }
      },
      "23": {
        start: {
          line: 57,
          column: 26
        },
        end: {
          line: 61,
          column: 1
        }
      },
      "24": {
        start: {
          line: 58,
          column: 20
        },
        end: {
          line: 58,
          column: 43
        }
      },
      "25": {
        start: {
          line: 59,
          column: 19
        },
        end: {
          line: 59,
          column: 49
        }
      },
      "26": {
        start: {
          line: 60,
          column: 2
        },
        end: {
          line: 60,
          column: 18
        }
      },
      "27": {
        start: {
          line: 63,
          column: 27
        },
        end: {
          line: 83,
          column: 1
        }
      },
      "28": {
        start: {
          line: 64,
          column: 17
        },
        end: {
          line: 64,
          column: 22
        }
      },
      "29": {
        start: {
          line: 65,
          column: 22
        },
        end: {
          line: 65,
          column: 66
        }
      },
      "30": {
        start: {
          line: 65,
          column: 42
        },
        end: {
          line: 65,
          column: 65
        }
      },
      "31": {
        start: {
          line: 66,
          column: 2
        },
        end: {
          line: 81,
          column: 5
        }
      },
      "32": {
        start: {
          line: 68,
          column: 23
        },
        end: {
          line: 68,
          column: 44
        }
      },
      "33": {
        start: {
          line: 69,
          column: 16
        },
        end: {
          line: 69,
          column: 48
        }
      },
      "34": {
        start: {
          line: 70,
          column: 15
        },
        end: {
          line: 70,
          column: 36
        }
      },
      "35": {
        start: {
          line: 71,
          column: 16
        },
        end: {
          line: 71,
          column: 38
        }
      },
      "36": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 80,
          column: 5
        }
      },
      "37": {
        start: {
          line: 72,
          column: 17
        },
        end: {
          line: 72,
          column: 18
        }
      },
      "38": {
        start: {
          line: 73,
          column: 19
        },
        end: {
          line: 73,
          column: 37
        }
      },
      "39": {
        start: {
          line: 74,
          column: 18
        },
        end: {
          line: 74,
          column: 42
        }
      },
      "40": {
        start: {
          line: 75,
          column: 19
        },
        end: {
          line: 75,
          column: 44
        }
      },
      "41": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 79,
          column: 7
        }
      },
      "42": {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 77,
          column: 24
        }
      },
      "43": {
        start: {
          line: 78,
          column: 8
        },
        end: {
          line: 78,
          column: 14
        }
      },
      "44": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 82,
          column: 18
        }
      },
      "45": {
        start: {
          line: 85,
          column: 28
        },
        end: {
          line: 90,
          column: 1
        }
      },
      "46": {
        start: {
          line: 86,
          column: 20
        },
        end: {
          line: 86,
          column: 39
        }
      },
      "47": {
        start: {
          line: 87,
          column: 20
        },
        end: {
          line: 87,
          column: 43
        }
      },
      "48": {
        start: {
          line: 88,
          column: 2
        },
        end: {
          line: 88,
          column: 29
        }
      },
      "49": {
        start: {
          line: 89,
          column: 2
        },
        end: {
          line: 89,
          column: 26
        }
      },
      "50": {
        start: {
          line: 92,
          column: 29
        },
        end: {
          line: 99,
          column: 1
        }
      },
      "51": {
        start: {
          line: 93,
          column: 20
        },
        end: {
          line: 93,
          column: 39
        }
      },
      "52": {
        start: {
          line: 94,
          column: 2
        },
        end: {
          line: 97,
          column: 5
        }
      },
      "53": {
        start: {
          line: 95,
          column: 22
        },
        end: {
          line: 95,
          column: 45
        }
      },
      "54": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 31
        }
      },
      "55": {
        start: {
          line: 98,
          column: 2
        },
        end: {
          line: 98,
          column: 26
        }
      },
      "56": {
        start: {
          line: 101,
          column: 31
        },
        end: {
          line: 109,
          column: 1
        }
      },
      "57": {
        start: {
          line: 102,
          column: 20
        },
        end: {
          line: 102,
          column: 43
        }
      },
      "58": {
        start: {
          line: 103,
          column: 31
        },
        end: {
          line: 105,
          column: 3
        }
      },
      "59": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 104,
          column: 33
        }
      },
      "60": {
        start: {
          line: 106,
          column: 22
        },
        end: {
          line: 106,
          column: 51
        }
      },
      "61": {
        start: {
          line: 107,
          column: 2
        },
        end: {
          line: 107,
          column: 32
        }
      },
      "62": {
        start: {
          line: 108,
          column: 2
        },
        end: {
          line: 108,
          column: 26
        }
      },
      "63": {
        start: {
          line: 111,
          column: 32
        },
        end: {
          line: 121,
          column: 1
        }
      },
      "64": {
        start: {
          line: 112,
          column: 31
        },
        end: {
          line: 114,
          column: 3
        }
      },
      "65": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 32
        }
      },
      "66": {
        start: {
          line: 115,
          column: 22
        },
        end: {
          line: 115,
          column: 51
        }
      },
      "67": {
        start: {
          line: 116,
          column: 2
        },
        end: {
          line: 119,
          column: 5
        }
      },
      "68": {
        start: {
          line: 117,
          column: 22
        },
        end: {
          line: 117,
          column: 45
        }
      },
      "69": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 34
        }
      },
      "70": {
        start: {
          line: 120,
          column: 2
        },
        end: {
          line: 120,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 35
          },
          end: {
            line: 6,
            column: 36
          }
        },
        loc: {
          start: {
            line: 6,
            column: 76
          },
          end: {
            line: 16,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 26
          },
          end: {
            line: 13,
            column: 51
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 18,
            column: 30
          },
          end: {
            line: 18,
            column: 31
          }
        },
        loc: {
          start: {
            line: 18,
            column: 64
          },
          end: {
            line: 34,
            column: 1
          }
        },
        line: 18
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 38
          }
        },
        loc: {
          start: {
            line: 20,
            column: 52
          },
          end: {
            line: 20,
            column: 78
          }
        },
        line: 20
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 21,
            column: 23
          },
          end: {
            line: 21,
            column: 24
          }
        },
        loc: {
          start: {
            line: 21,
            column: 47
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 21
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 46,
            column: 33
          },
          end: {
            line: 46,
            column: 34
          }
        },
        loc: {
          start: {
            line: 46,
            column: 43
          },
          end: {
            line: 55,
            column: 1
          }
        },
        line: 46
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 57,
            column: 26
          },
          end: {
            line: 57,
            column: 27
          }
        },
        loc: {
          start: {
            line: 57,
            column: 52
          },
          end: {
            line: 61,
            column: 1
          }
        },
        line: 57
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 63,
            column: 27
          },
          end: {
            line: 63,
            column: 28
          }
        },
        loc: {
          start: {
            line: 63,
            column: 54
          },
          end: {
            line: 83,
            column: 1
          }
        },
        line: 63
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 65,
            column: 32
          },
          end: {
            line: 65,
            column: 33
          }
        },
        loc: {
          start: {
            line: 65,
            column: 42
          },
          end: {
            line: 65,
            column: 65
          }
        },
        line: 65
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 66,
            column: 22
          },
          end: {
            line: 66,
            column: 23
          }
        },
        loc: {
          start: {
            line: 66,
            column: 37
          },
          end: {
            line: 81,
            column: 3
          }
        },
        line: 66
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 85,
            column: 28
          },
          end: {
            line: 85,
            column: 29
          }
        },
        loc: {
          start: {
            line: 85,
            column: 54
          },
          end: {
            line: 90,
            column: 1
          }
        },
        line: 85
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 92,
            column: 29
          },
          end: {
            line: 92,
            column: 30
          }
        },
        loc: {
          start: {
            line: 92,
            column: 56
          },
          end: {
            line: 99,
            column: 1
          }
        },
        line: 92
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 94,
            column: 16
          },
          end: {
            line: 94,
            column: 17
          }
        },
        loc: {
          start: {
            line: 94,
            column: 26
          },
          end: {
            line: 97,
            column: 3
          }
        },
        line: 94
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 101,
            column: 31
          },
          end: {
            line: 101,
            column: 32
          }
        },
        loc: {
          start: {
            line: 101,
            column: 57
          },
          end: {
            line: 109,
            column: 1
          }
        },
        line: 101
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 103,
            column: 46
          },
          end: {
            line: 103,
            column: 47
          }
        },
        loc: {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 104,
            column: 33
          }
        },
        line: 104
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 111,
            column: 32
          },
          end: {
            line: 111,
            column: 33
          }
        },
        loc: {
          start: {
            line: 111,
            column: 59
          },
          end: {
            line: 121,
            column: 1
          }
        },
        line: 111
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 112,
            column: 46
          },
          end: {
            line: 112,
            column: 47
          }
        },
        loc: {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 32
          }
        },
        line: 113
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 116,
            column: 16
          },
          end: {
            line: 116,
            column: 17
          }
        },
        loc: {
          start: {
            line: 116,
            column: 26
          },
          end: {
            line: 119,
            column: 3
          }
        },
        line: 116
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 14,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 14,
            column: 3
          }
        }, {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 14,
            column: 3
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 8,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 8,
            column: 11
          }
        }, {
          start: {
            line: 8,
            column: 15
          },
          end: {
            line: 8,
            column: 27
          }
        }, {
          start: {
            line: 8,
            column: 31
          },
          end: {
            line: 8,
            column: 41
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        }, {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        }],
        line: 23
      },
      "3": {
        loc: {
          start: {
            line: 25,
            column: 25
          },
          end: {
            line: 25,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 25,
            column: 33
          },
          end: {
            line: 25,
            column: 37
          }
        }, {
          start: {
            line: 25,
            column: 40
          },
          end: {
            line: 25,
            column: 43
          }
        }],
        line: 25
      },
      "4": {
        loc: {
          start: {
            line: 49,
            column: 10
          },
          end: {
            line: 49,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 10
          },
          end: {
            line: 49,
            column: 17
          }
        }, {
          start: {
            line: 49,
            column: 21
          },
          end: {
            line: 49,
            column: 25
          }
        }],
        line: 49
      },
      "5": {
        loc: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 79,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 79,
            column: 7
          }
        }, {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 79,
            column: 7
          }
        }],
        line: 76
      },
      "6": {
        loc: {
          start: {
            line: 76,
            column: 10
          },
          end: {
            line: 76,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 76,
            column: 10
          },
          end: {
            line: 76,
            column: 24
          }
        }, {
          start: {
            line: 76,
            column: 28
          },
          end: {
            line: 76,
            column: 40
          }
        }, {
          start: {
            line: 76,
            column: 44
          },
          end: {
            line: 76,
            column: 58
          }
        }],
        line: 76
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "bc8b9987ef6a3617a3618950eea28f7c101eeeca"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.removeSelections = exports.removeSelection = exports.addSelections = exports.addSelection = exports.areSelected = exports.isSelected = exports.selectionFromWord = exports.quoteFromVerse = exports.selectionsFromQuote = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _selections2 = require("../../core/selections/selections");

cov_1lk1ozh6e6.s[0]++; // const stringify = (array) => array.map(object => JSON.stringify(object));
//export const parsify = (array) => array.map(string => JSON.parse(string));

var selectionsFromQuote = function selectionsFromQuote(_ref) {
  var quote = _ref.quote,
      verseObjects = _ref.verseObjects,
      occurrence = _ref.occurrence;
  cov_1lk1ozh6e6.f[0]++;
  var selections = (cov_1lk1ozh6e6.s[1]++, []);
  cov_1lk1ozh6e6.s[2]++;

  if ((cov_1lk1ozh6e6.b[1][0]++, quote) && (cov_1lk1ozh6e6.b[1][1]++, verseObjects) && (cov_1lk1ozh6e6.b[1][2]++, occurrence)) {
    cov_1lk1ozh6e6.b[0][0]++;
    cov_1lk1ozh6e6.s[3]++;
    selections = (0, _selections2.selectionsFromQuoteAndVerseObjects)({
      quote: quote,
      verseObjects: verseObjects,
      occurrence: occurrence
    }).map(function (selection) {
      cov_1lk1ozh6e6.f[1]++;
      cov_1lk1ozh6e6.s[4]++;
      return JSON.stringify(selection);
    });
  } else {
    cov_1lk1ozh6e6.b[0][1]++;
  }

  cov_1lk1ozh6e6.s[5]++;
  return selections;
};

exports.selectionsFromQuote = selectionsFromQuote;
cov_1lk1ozh6e6.s[6]++;

var quoteFromVerse = function quoteFromVerse(_ref2) {
  var selections = _ref2.selections,
      verseObjects = _ref2.verseObjects;
  cov_1lk1ozh6e6.f[2]++;
  var quotedWords = (cov_1lk1ozh6e6.s[7]++, new Array(verseObjects.length));

  var _selections = (cov_1lk1ozh6e6.s[8]++, selections.map(function (selection) {
    cov_1lk1ozh6e6.f[3]++;
    cov_1lk1ozh6e6.s[9]++;
    return JSON.parse(selection).text;
  }));

  cov_1lk1ozh6e6.s[10]++;
  verseObjects.forEach(function (verseObject, index) {
    cov_1lk1ozh6e6.f[4]++;

    var _ref3 = (cov_1lk1ozh6e6.s[11]++, verseObject),
        type = _ref3.type,
        text = _ref3.text;

    cov_1lk1ozh6e6.s[12]++;

    if (type === 'word') {
      cov_1lk1ozh6e6.b[2][0]++;
      var match = (cov_1lk1ozh6e6.s[13]++, _selections.includes(text));
      var quotedWord = (cov_1lk1ozh6e6.s[14]++, match ? (cov_1lk1ozh6e6.b[3][0]++, text) : (cov_1lk1ozh6e6.b[3][1]++, '…'));
      cov_1lk1ozh6e6.s[15]++;
      quotedWords.push(quotedWord);
    } else {
      cov_1lk1ozh6e6.b[2][1]++;
    }
  });
  var quote = (cov_1lk1ozh6e6.s[16]++, quotedWords.join(' ').replace(/( ?… ?)+/g, ' … ').replace(/(^[… ]+|[… ]+$)/g, ''));
  cov_1lk1ozh6e6.s[17]++;
  return quote;
}; // const wordsFromMilestone = ({milestone, quotedWords=[]}) => {
//   const _selections = selections.map(selection => selection.text);
//   if (_selections.include(milestone.content)) {
//     if (milestone.children[0].type === 'word') {
//       const words = milestone.children;
//       words.forEach(word => quotedWords.push(word.text));
//     }
//   }
// };


exports.quoteFromVerse = quoteFromVerse;
cov_1lk1ozh6e6.s[18]++;

var selectionFromWord = function selectionFromWord(word) {
  cov_1lk1ozh6e6.f[5]++;

  var _ref4 = (cov_1lk1ozh6e6.s[19]++, word),
      content = _ref4.content,
      text = _ref4.text,
      occurrence = _ref4.occurrence,
      occurrences = _ref4.occurrences;

  var selectionObject = (cov_1lk1ozh6e6.s[20]++, {
    text: (cov_1lk1ozh6e6.b[4][0]++, content) || (cov_1lk1ozh6e6.b[4][1]++, text),
    occurrence: parseInt(occurrence),
    occurrences: parseInt(occurrences)
  });
  var selection = (cov_1lk1ozh6e6.s[21]++, JSON.stringify(selectionObject));
  cov_1lk1ozh6e6.s[22]++;
  return selection;
};

exports.selectionFromWord = selectionFromWord;
cov_1lk1ozh6e6.s[23]++;

var isSelected = function isSelected(_ref5) {
  var word = _ref5.word,
      selections = _ref5.selections;
  cov_1lk1ozh6e6.f[6]++;
  var selection = (cov_1lk1ozh6e6.s[24]++, selectionFromWord(word));
  var selected = (cov_1lk1ozh6e6.s[25]++, selections.includes(selection));
  cov_1lk1ozh6e6.s[26]++;
  return selected;
};

exports.isSelected = isSelected;
cov_1lk1ozh6e6.s[27]++;

var areSelected = function areSelected(_ref6) {
  var words = _ref6.words,
      selections = _ref6.selections;
  cov_1lk1ozh6e6.f[7]++;
  var selected = (cov_1lk1ozh6e6.s[28]++, false);

  var _selections = (cov_1lk1ozh6e6.s[29]++, words.map(function (word) {
    cov_1lk1ozh6e6.f[8]++;
    cov_1lk1ozh6e6.s[30]++;
    return selectionFromWord(word);
  }));

  cov_1lk1ozh6e6.s[31]++;

  _selections.forEach(function (selection) {
    cov_1lk1ozh6e6.f[9]++; //if (selections.includes(_s)) selected = true;

    var _selection = (cov_1lk1ozh6e6.s[32]++, JSON.parse(selection));

    var _text = (cov_1lk1ozh6e6.s[33]++, (0, _selections2.normalizeString)(_selection.text));

    var _occ = (cov_1lk1ozh6e6.s[34]++, _selection.occurrence);

    var _occs = (cov_1lk1ozh6e6.s[35]++, _selection.occurrences);

    cov_1lk1ozh6e6.s[36]++;

    for (var i = (cov_1lk1ozh6e6.s[37]++, 0); i < selections.length; i++) {
      var text = (cov_1lk1ozh6e6.s[38]++, selections[i].text); //already normalized.

      var occ = (cov_1lk1ozh6e6.s[39]++, selections[i].occurrence);
      var occs = (cov_1lk1ozh6e6.s[40]++, selections[i].occurrences);
      cov_1lk1ozh6e6.s[41]++;

      if ((cov_1lk1ozh6e6.b[6][0]++, text === _text) && (cov_1lk1ozh6e6.b[6][1]++, occ === _occ) && (cov_1lk1ozh6e6.b[6][2]++, occs === _occs)) {
        cov_1lk1ozh6e6.b[5][0]++;
        cov_1lk1ozh6e6.s[42]++;
        selected = true;
        cov_1lk1ozh6e6.s[43]++;
        break;
      } else {
        cov_1lk1ozh6e6.b[5][1]++;
      }
    }
  });

  cov_1lk1ozh6e6.s[44]++;
  return selected;
};

exports.areSelected = areSelected;
cov_1lk1ozh6e6.s[45]++;

var addSelection = function addSelection(_ref7) {
  var word = _ref7.word,
      selections = _ref7.selections;
  cov_1lk1ozh6e6.f[10]++;

  var _selections = (cov_1lk1ozh6e6.s[46]++, new Set(selections));

  var selection = (cov_1lk1ozh6e6.s[47]++, selectionFromWord(word));
  cov_1lk1ozh6e6.s[48]++;

  _selections.add(selection);

  cov_1lk1ozh6e6.s[49]++;
  return (0, _toConsumableArray2.default)(_selections);
};

exports.addSelection = addSelection;
cov_1lk1ozh6e6.s[50]++;

var addSelections = function addSelections(_ref8) {
  var words = _ref8.words,
      selections = _ref8.selections;
  cov_1lk1ozh6e6.f[11]++;

  var _selections = (cov_1lk1ozh6e6.s[51]++, new Set(selections));

  cov_1lk1ozh6e6.s[52]++;
  words.forEach(function (word) {
    cov_1lk1ozh6e6.f[12]++;
    var selection = (cov_1lk1ozh6e6.s[53]++, selectionFromWord(word));
    cov_1lk1ozh6e6.s[54]++;

    _selections.add(selection);
  });
  cov_1lk1ozh6e6.s[55]++;
  return (0, _toConsumableArray2.default)(_selections);
};

exports.addSelections = addSelections;
cov_1lk1ozh6e6.s[56]++;

var removeSelection = function removeSelection(_ref9) {
  var word = _ref9.word,
      selections = _ref9.selections;
  cov_1lk1ozh6e6.f[13]++;
  var selection = (cov_1lk1ozh6e6.s[57]++, selectionFromWord(word));
  var selectionStringified = (cov_1lk1ozh6e6.s[58]++, selections.map(function (_selection) {
    cov_1lk1ozh6e6.f[14]++;
    cov_1lk1ozh6e6.s[59]++;
    return selectionFromWord(_selection);
  }));

  var _selections = (cov_1lk1ozh6e6.s[60]++, new Set(selectionStringified));

  cov_1lk1ozh6e6.s[61]++;

  _selections.delete(selection);

  cov_1lk1ozh6e6.s[62]++;
  return (0, _toConsumableArray2.default)(_selections);
};

exports.removeSelection = removeSelection;
cov_1lk1ozh6e6.s[63]++;

var removeSelections = function removeSelections(_ref10) {
  var words = _ref10.words,
      selections = _ref10.selections;
  cov_1lk1ozh6e6.f[15]++;
  var selectionStringified = (cov_1lk1ozh6e6.s[64]++, selections.map(function (selection) {
    cov_1lk1ozh6e6.f[16]++;
    cov_1lk1ozh6e6.s[65]++;
    return selectionFromWord(selection);
  }));

  var _selections = (cov_1lk1ozh6e6.s[66]++, new Set(selectionStringified));

  cov_1lk1ozh6e6.s[67]++;
  words.forEach(function (word) {
    cov_1lk1ozh6e6.f[17]++;
    var selection = (cov_1lk1ozh6e6.s[68]++, selectionFromWord(word));
    cov_1lk1ozh6e6.s[69]++;

    _selections.delete(selection);
  });
  cov_1lk1ozh6e6.s[70]++;
  return (0, _toConsumableArray2.default)(_selections);
};

exports.removeSelections = removeSelections;
var _default = {
  selectionFromWord: selectionFromWord,
  isSelected: isSelected,
  areSelected: areSelected,
  addSelection: addSelection,
  addSelections: addSelections,
  removeSelection: removeSelection,
  removeSelections: removeSelections
};
exports.default = _default;